module.exports = __webpack_public_path__ + "medias/fonts/topmora.svg";